import r from "./keys.js";
function t(t) {
  for (var e = {}, n = r(t), o = 0, f = n.length; o < f; o++) e[t[n[o]]] = n[o];
  return e;
}
export { t as default };